import React from 'react';
import { getOptimizedImageUrl } from '@/utils/imageUtils';
import { StoryPost } from '@/hooks/useDishStoryPosts';

interface StoryImageSlideProps {
  post: StoryPost;
  imageUrl: string;
  onNext: () => void;
  onPrev: () => void;
}

const StoryImageSlide: React.FC<StoryImageSlideProps> = ({ post, imageUrl, onNext, onPrev }) => {
  if (!imageUrl) return null;

  return (
    <div className="absolute inset-0">
      {/* Atmospheric blur background */}
      <img
        src={getOptimizedImageUrl(imageUrl, 50, 50)}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover blur-3xl opacity-60 scale-110"
      />
      {/* Full-res foreground */}
      <img
        src={getOptimizedImageUrl(imageUrl, 800, 1200)}
        alt={post.content || 'Post image'}
        className="relative w-full h-full object-contain z-10"
      />

      {/* Left tap zone (1/3 width) */}
      <div
        className="absolute left-0 top-0 w-1/3 h-full z-10 cursor-pointer"
        onClick={(e) => { e.stopPropagation(); onPrev(); }}
      />

      {/* Right tap zone (1/3 width) */}
      <div
        className="absolute right-0 top-0 w-1/3 h-full z-10 cursor-pointer"
        onClick={(e) => { e.stopPropagation(); onNext(); }}
      />
    </div>
  );
};

export default StoryImageSlide;
